'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bpfrpt_proptype_AlignType = exports.bpfrpt_proptype_PositionType = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var bpfrpt_proptype_PositionType = _propTypes2.default.oneOf(['top', 'bottom', 'right']);

var bpfrpt_proptype_AlignType = _propTypes2.default.oneOf(['top', 'bottom', 'left', 'right']);

exports.bpfrpt_proptype_PositionType = bpfrpt_proptype_PositionType;
exports.bpfrpt_proptype_AlignType = bpfrpt_proptype_AlignType;